export type UsageBreakdownItem = {
  label: string;
  value: number;
  color: string;
};

type Props = {
  title: string;
  total: number;
  items: UsageBreakdownItem[];
};

export default function UsageBreakdownCard({ title, total, items }: Props) {
  return (
    <div className="flex-1 p-5 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-gray-D flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <div className="text-gray-B text-sm font-semibold">{title}</div>
        <div className="text-2xl font-semibold">{total.toLocaleString()}</div>
      </div>
      <div className="flex flex-col gap-2">
        {items.map((item) => (
          <div
            key={item.label}
            className="flex justify-between items-center text-sm"
          >
            <div className="flex items-center gap-2">
              <div
                className="w-2 h-2 rounded-full"
                style={{ backgroundColor: item.color }}
              />
              <span className="text-gray-A">{item.label}</span>
            </div>
            <span className="font-semibold">{item.value.toLocaleString()}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
